import React from "react";
import { getWithExpiry } from '../../common';
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";

const OviPersonalSummary = (props) => {

    const [cookies] = useCookies(["sustainyou_user_jwt"]);

    const userHvi = props.userHvi;

    const questions = [
        'Tydliga visioner och mål',
        'Bidrar till organisationens resultat',
        'Prioriterar varje dag',
        'Tydliga ansvarsområden och mål',
        'Har resurser för arbetsuppgifterna',
        'Delar organisationens värderingar',
        'Värderingarna är viktiga',
        'Tillit till sin chef',
        'Kollegialt stöd',
        'Trygg i gruppen och kan vara sig själv',
        'Hinner genomföra förändringar',
        'Förtroende för ledningen'
    ];

    const getHviColor = (value, type) => {

        let color = 'sy-red';

        if ( type === 'total' ) {
            if ( value > 24 && value < 60 ) {
                color = 'sy-yellow';
            }
    
            if ( value > 59 ) {
                color = 'dark-green';
            }
        } else {
            if (  value === 3 || value === 4 ) {
                color = 'sy-yellow';
            }
    
            if (  value === 5 || value === 6 ) {
                color = 'sy-green';
            }
        }

        return color;

    }

    let recentHVI = userHvi;
    
    if ( userHvi?.length > 1 ) {
        recentHVI = userHvi?.slice(Math.max(userHvi.length - 5, 0));
    }

    if ( ! recentHVI ) {
        recentHVI = [];
    }


    if ( props?.isNew ) {
        const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
        const newHvi = getWithExpiry( `sy_${jwtDecoded.id}_recent_ovi` );

        recentHVI.push(newHvi);
    }

    return(
        <div className="hvi-summary-wrap mt-5 mb-6">
            <table className="table table-hover table-striped">
                <thead className="table-light">
                    <tr>
                        <th scope="col">#</th>
                        <th></th>
                        { recentHVI?.map( (hvi, index) => {
                            const date = hvi.date.split('-');
                            const formatter = new Intl.DateTimeFormat('sv', { month: 'short' });
                            const month = formatter.format(new Date(hvi.date));

                            return (
                                <th scope="col" className="text-center" key={index}>{`${date[2]} `}<span className="text-capitalize">{month}</span></th>
                            );
                        }) }
                    </tr>
                </thead>
                <tbody>
                    { questions.map( (question, qindex ) => {
                        return(
                            <tr key={qindex}>
                                <th scope="row">{qindex+1}.</th>
                                <th>{question}</th>
                                { recentHVI?.map( (hvi, index) => {
                                    return (
                                        <td key={index} className="text-center"><span className={`bg-${getHviColor( hvi.data[qindex].value , 'single')} text-white py-2 px-4`}>{hvi.data[qindex].value}</span></td>
                                    );
                                }) }
                            </tr>
                        );
                        
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td></td>
                        <td className="fw-bold pt-4 pb-3">Total</td>
                        { recentHVI?.map( (hvi, index) => {
                            return (
                                <td key={index} className="text-center pt-4 pb-3"><span className={`bg-${getHviColor( hvi.ovi_count , 'total')} text-white py-2 px-4`}>{hvi.ovi_count}</span></td>
                            );
                        }) }
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default OviPersonalSummary;